import { cn } from '@/context/global/utils/cn';

interface PlayWarningProps {
  className?: string;
}

const MaintenanceSvg = ({ className }: PlayWarningProps) => {
  return (
    <svg
      className={cn('text-ais-green', className)}
      width="152"
      height="123"
      viewBox="0 0 152 123"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_59072)">
        <path
          d="M16.999 40.6709C18.1309 40.6709 19.1248 40.893 19.8105 41.2227C20.5447 41.5756 20.7176 41.9335 20.7178 42.1104V119.484C20.7175 119.661 20.5441 120.018 19.8105 120.371C19.1248 120.701 18.1309 120.924 16.999 120.924C15.8671 120.924 14.8733 120.701 14.1875 120.371C13.4537 120.018 13.2806 119.661 13.2803 119.484V42.1104C13.2804 41.9335 13.4532 41.5756 14.1875 41.2227C14.8733 40.893 15.8672 40.6709 16.999 40.6709Z"
          fill="#9E9E9E"
          stroke="#5E5E5E"
          strokeWidth="1.33333"
        />
        <path
          d="M29.999 115.337V120.67H3.33301V115.337H29.999Z"
          fill="#9E9E9E"
          stroke="#5E5E5E"
          strokeWidth="1.33333"
        />
        <path
          d="M135.667 40.6709C136.799 40.6709 137.793 40.893 138.479 41.2227C139.213 41.5756 139.386 41.9335 139.386 42.1104V119.484C139.385 119.661 139.212 120.018 138.479 120.371C137.793 120.701 136.799 120.924 135.667 120.924C134.535 120.924 133.541 120.701 132.855 120.371C132.122 120.018 131.949 119.661 131.948 119.484V42.1104C131.948 41.9335 132.121 41.5756 132.855 41.2227C133.541 40.893 134.535 40.6709 135.667 40.6709Z"
          fill="#9E9E9E"
          stroke="#5E5E5E"
          strokeWidth="1.33333"
        />
        <path
          d="M148.667 115.337V120.67H122.001V115.337H148.667Z"
          fill="#9E9E9E"
          stroke="#5E5E5E"
          strokeWidth="1.33333"
        />
        <path d="M151.907 40.0039H0V76.3506H151.907V40.0039Z" fill="currentColor" />
        <path
          d="M7.93333 40.0039H0V56.7639L17.9467 76.3506H41.24L7.93333 40.0039Z"
          fill="#5E5E5E"
        />
        <path
          d="M82.2543 76.3506L48.9476 40.0039H25.6543L58.961 76.3506H82.2543Z"
          fill="#5E5E5E"
        />
        <path
          d="M123.266 76.3506L89.9593 40.0039H66.666L99.9727 76.3506H123.266Z"
          fill="#5E5E5E"
        />
        <path
          d="M151.906 62.8439L130.973 40.0039H107.68L140.986 76.3506H151.906V62.8439Z"
          fill="#5E5E5E"
        />
      </g>
      <g clipPath="url(#clip1_1_59072)">
        <path
          d="M93.1126 38.5H62.402L56.0625 57.3431H99.4521L93.1126 38.5Z"
          fill="#444444"
        />
        <path
          d="M86.293 20.3447L92.1836 37.832H63.3281L69.2188 20.3447H86.293Z"
          fill="#9E9E9E"
          stroke="#5E5E5E"
          strokeWidth="1.33333"
        />
        <path
          d="M81.1322 2.9175C80.5399 1.14068 79.2237 0 77.754 0C76.3062 0 74.9901 1.14068 74.3759 2.9175L68.7383 19.6767H86.7698L81.1322 2.9175Z"
          fill="#444444"
        />
        <path
          d="M111.672 95.6514L117.848 113.994H37.6621L43.8379 95.6514H111.672Z"
          fill="#9E9E9E"
          stroke="#5E5E5E"
          strokeWidth="1.33333"
        />
        <path
          d="M105.813 76.1641H49.7009L43.3613 94.9852H112.153L105.813 76.1641Z"
          fill="#444444"
        />
        <path
          d="M98.9717 58.0088L104.883 75.4961H50.6289L56.5391 58.0088H98.9717Z"
          fill="#9E9E9E"
          stroke="#5E5E5E"
          strokeWidth="1.33333"
        />
        <path
          d="M35.4843 111.699H120.026C124.896 111.699 128.844 115.648 128.844 120.518V122.667H26.666V120.518C26.666 115.648 30.6145 111.699 35.4843 111.699Z"
          fill="#444444"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_59072">
          <rect
            width="151.907"
            height="81.5867"
            fill="white"
            transform="translate(0 40.002)"
          />
        </clipPath>
        <clipPath id="clip1_1_59072">
          <rect
            width="102.178"
            height="122.667"
            fill="white"
            transform="translate(26.666)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MaintenanceSvg;
